import React from "react";
import { Link } from "react-router-dom";

export default function ServiceCard({ service }) {
  return (
    <Link to={`/services/${service.slug}`} className="service-card">
      <div className="service-card-icon"></div>
      <h3 className="service-card-title">{service.title}</h3>
      <p className="service-card-desc">{service.desc}</p>

      <div className="service-card-footer">
        <span className="service-card-price">{service.price} {service.priceNote}</span>
        <span className="btn-mu-outline">View Details &rarr;</span>
      </div>
    </Link>
  );
}
